import { useTransitionAnimation } from "@/hooks/useTransitionAnimation";
import dollarsign from "@/assets/dollarsign.svg";
import type { PurchaseState } from "./Modals/PurchaseModal";
// import { PaymentInstrumentsResponse } from "./PaymentsList";
// import { useFirebaseFunction } from "@/hooks/useFirebaseFunction";
// import paypal from "@/assets/paypal.svg";
// import mastercard from "@/assets/mastercard.svg";
// import visa from "@/assets/visa.svg";
// import amex from "@/assets/amex.svg";
// import discover from "@/assets/discover.svg";
// import { CircularLoadingSpinner } from "./CircularLoadingSpinner/CircularLoadingSpinner";


interface BottomTagProps {
  purchaseState: PurchaseState;
}

export function BottomTag({ purchaseState }: BottomTagProps) {
  const { visibleState, getAnimationClass } = useTransitionAnimation<PurchaseState>(purchaseState);

  return (
    <>
      {(() => {
        switch (visibleState) {
          case 'options':
            return (
              <div 
                className={`
                  absolute p-3 bottom-0 
                  flex justify-center items-center
                  w-full transition-all duration-300 ease-in-out
                  ${getAnimationClass()}
                `}
              >
                {/* <OneTapCheckout /> */}
              </div>
            )
          case 'checkout' as PurchaseState:
            return (
              <div 
                className={`
                  absolute bg-emerald-50 text-white p-3 bottom-0 
                  flex justify-center items-center border-t border-emerald-200 
                  rounded-bl-lg rounded-br-lg w-full
                  transition-all duration-300 ease-in-out
                  ${getAnimationClass()}
                `}
              >
                <h1 className="text-xl font-bold text-emerald-400 flex items-center justify-center gap-1.5">
                  <img src={dollarsign} alt='dollarsign' className='h-7'/>
                  Ready to win?
                </h1>
              </div>
            );
          case 'checkout-failed' as PurchaseState:
            return (
              <div 
                className={`
                  absolute bg-red-50 text-white p-3 bottom-0 
                  flex justify-center items-center border-t border-red-200 
                  rounded-bl-lg rounded-br-lg w-full
                  transition-all duration-300 ease-in-out
                  ${getAnimationClass()}
                `}
              >
                <h1 className="text-xl font-bold text-red-400 flex items-center justify-center gap-1.5 text-center">
                  {/* <img src={dollarsign} alt='dollarsign' className='h-7'/> */}
                  Payment failed. Retry or try a new card
                </h1>
              </div>
            );
          default:
            return null;
        }
      })()}
    </>
  );
}

// function OneTapCheckout() {
//   const [paymentMethods, isPaymentMethodsLoading] = useFirebaseFunction<void, PaymentInstrumentsResponse>(
//     "getPaymentInstruments",
//     (fn) => fn(),
//     []
//   );

//   if (isPaymentMethodsLoading) {
//     return (
//       <div className=" h-full p-3 flex justify-center items-center">
//         <h1 className="text-gray-400 font-medium text-lg">1-tap checkout with </h1>
//         <span className="ml-2 translate-y-[1px]">
//             <CircularLoadingSpinner />
//           </span>
//       </div>
//     )
//   }

//   if (!paymentMethods?.data[0] || paymentMethods?.data.length === 0) {
//     return null
//   }

//   const image = getPaymentMethodImage(paymentMethods.data[0]);

//   return (
//     <div className=" h-full p-3 flex justify-center items-center">
//       <h1 className="text-gray-400 font-medium text-lg">1-tap checkout with 
//         <img src={image.src} className="h-8" alt={image.alt} />
//       </h1>
//     </div>
//   )
// }

// const MASTERCARD = "MASTERCARD";
// const VISA = "VISA";
// const AMEX = "AMEX";
// const DISCOVER = "DISCOVER";

// function getPaymentMethodImage(method: PaymentInstrumentsResponse["data"][0]) {
//   // Check for payment type
//   // if (method.paymentInstrumentType === "APPLE_PAY") {
//   //   return { src: applepay, alt: "Apple Pay" };
//   // }
  
//   // Get network from paymentInstrumentData if it exists
//   const network = method.paymentInstrumentData?.network;
  
//   // Determine image based on network
//   if (network) {
//     switch (network) {
//       case MASTERCARD:
//         return { src: mastercard, alt: "mastercard" };
//       case VISA:
//         return { src: visa, alt: "visa" };
//       case AMEX:
//         return { src: amex, alt: "american express" };
//       case DISCOVER:
//         return { src: discover, alt: "discover" };
//     }
//   }
  
//   // Fallback for PayPal or other payment types
//   return { src: paypal, alt: "payment method" };
// };